export default __webpack_public_path__ + "static/media/combi.388b6bd2.pdf";